var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1047 3.49049C15.3505 2.99591 15.9507 2.79422 16.4452 3.04001C19.7355 4.67514 22.0002 8.07218 22.0002 12C22.0002 15.9278 19.7355 19.3249 16.4452 20.96C15.9507 21.2058 15.3505 21.0041 15.1047 20.5095C14.8589 20.0149 15.0606 19.4148 15.5552 19.169C18.1918 17.8587 20.0002 15.1396 20.0002 12C20.0002 8.86038 18.1918 6.14131 15.5552 4.83104C15.0606 4.58525 14.8589 3.98507 15.1047 3.49049Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.00005H4C2.89543 8.00005 2 8.89548 2 10V14C2 15.1046 2.89543 16 4 16H6L10.3598 19.6332C11.0111 20.176 12 19.7128 12 18.865V5.1351C12 4.28726 11.0111 3.8241 10.3598 4.36687L6 8.00005Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7996 8.39948C16.4679 7.95789 15.8411 7.8688 15.3995 8.20049C14.9579 8.53218 14.8688 9.15904 15.2005 9.60063C15.7026 10.2691 15.9997 11.0985 15.9997 12.0001C15.9997 12.9017 15.7026 13.7311 15.2005 14.3995C14.8688 14.8411 14.9579 15.468 15.3995 15.7997C15.8411 16.1314 16.4679 16.0423 16.7996 15.6007C17.5529 14.5978 17.9997 13.3497 17.9997 12.0001C17.9997 10.6505 17.5529 9.40236 16.7996 8.39948Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/sound.137694bfbf9e599ee89e5f423acdc7ab.svg";
export { ForwardRef as ReactComponent };